(function() {
  jQuery(function() {
    let getCountriesValue;
 
    let statesUrl = '/users/states',
        countriesInput = $('#countries'),
        states = document.getElementById("states"),
        cities = document.getElementById("cities");
   
    let previousCountry = null,
        result = {}; 

    function buildOption(data, currentState, selectOption){

      let options = (data.states) ? data.states : data.cities

      for(var item of options){
        var el = document.createElement("option");
        el.textContent = item;
        if(item == currentState) el.setAttribute('selected', true);
        
        if(selectOption == "state") states.appendChild(el);
        if(selectOption == "city") cities.appendChild(el);
        
      }
    }

    function loadState(){

      var data = {
        country: countriesInput.val(),
      };

      return $.ajax({
        type: 'GET',
        url: statesUrl,
        data: data,
        success: function(data) {
        
          //clear state if change country
          if (previousCountry !== countriesInput.val()){
            $(states).empty();
          }

          let hiddenState = ($(states).find('option').text() == "") ? 
                        data.states[0] : 
                        $(states).find('option:selected').text();

          let getExistState = (data.states.length > 0) ? 
            data.states?.filter((item) => item == hiddenState) : 
            hiddenState;

          let params = {
            country: countriesInput.val(),
            state: getExistState 
          }; 

          //need for city select
          result = {...params};
          
          //remove duplicate in state
          states.textContent = '';

          if(states) while (states.firstChild) states.removeChild(states.firstChild);
      
          if( params.state?.length > 0){
              $('#states').closest('.form-group').show();
              $('#cities').closest('.form-group').show();
              buildOption(data, params.state, "state");

              previousCountry = countriesInput.val();
          }else{
            $('#states').closest('.form-group').hide();
            $('#cities').closest('.form-group').hide();
            $(states).empty();
            $(cities).empty();
          }
        }
      });
    }

    function loadCity(params){
      
      return $.ajax({
        type:'GET',
        url:'/users/cities',
        data: params,
        success: function(data){
          
          $(cities).empty();
          hiddenState = data.cities[0];

          if(data.cities) buildOption(data, hiddenState, "city");
        },
        error: function(e){
          console.log('Something went wrong with City field select');
          $(cities).empty();
        }
      });
    }

    getCountriesValue = function() {
      $.when( loadState() ).then(function() {
        loadCity(result);
      });
    };

    getCountriesValue();
    $("#countries, #states").on('change', function () {
      getCountriesValue();
    });

  });
}).call(this);
